import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/Button';
import { MenuIcon, XIcon } from 'lucide-react';
import { ThemeToggle } from '../ui/ThemeToggle';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Developers',
    path: '/developers'
  }, {
    name: 'Jobs',
    path: '/jobs'
  }, {
    name: 'Companies',
    path: '/post-job'
  }, {
    name: 'Pricing',
    path: '/pricing'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMenuOpen ? 'bg-background/90 backdrop-blur-md border-b border-border' : 'bg-transparent'}`} data-id="element-115">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="flex items-center justify-between h-20" data-id="element-117">
          {/* Logo */}
          <Link to="/" className="flex items-center group" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/d9J21SdPa4fZ4qb3dUNXgc/2.png" alt="CertifiedDevs" className="h-20 w-auto" data-id="element-119" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-120">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors duration-200 ${isActive(link.path) ? 'text-primary' : 'text-text-muted hover:text-text-main'}`} data-id="element-121">
                {link.name}
              </Link>)}
          </nav>

          {/* Auth Buttons & Theme Toggle */}
          <div className="hidden md:flex items-center gap-4" data-id="element-122">
            <ThemeToggle data-id="element-123" />
            <Link to="/login" className="text-sm font-medium text-text-muted hover:text-text-main transition-colors" data-id="element-124">
              Log in
            </Link>
            <Link to="/signup" data-id="element-125">
              <Button variant="primary" size="sm" className="shadow-lg shadow-red-500/20 hover:shadow-red-500/30" data-id="element-126">
                Get Certified
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-4" data-id="element-127">
            <ThemeToggle data-id="element-128" />
            <button className="p-2 text-text-muted hover:text-text-main transition-colors" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-129">
              {isMenuOpen ? <XIcon className="w-6 h-6" data-id="element-130" /> : <MenuIcon className="w-6 h-6" data-id="element-131" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-background border-b border-border" data-id="element-132">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-133">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`block px-3 py-3 rounded-lg text-base font-medium ${isActive(link.path) ? 'bg-primary/10 text-primary' : 'text-text-muted hover:bg-surface hover:text-text-main'}`} onClick={() => setIsMenuOpen(false)} data-id="element-134">
                {link.name}
              </Link>)}
            <div className="pt-4 mt-4 border-t border-border flex flex-col gap-3" data-id="element-135">
              <Link to="/login" className="block px-3 py-3 text-center rounded-lg text-base font-medium text-text-muted hover:bg-surface hover:text-text-main" onClick={() => setIsMenuOpen(false)} data-id="element-136">
                Log in
              </Link>
              <Link to="/signup" onClick={() => setIsMenuOpen(false)} data-id="element-137">
                <Button className="w-full justify-center" data-id="element-138">Get Certified</Button>
              </Link>
            </div>
          </div>
        </div>}
    </header>;
};